const RUB_FORMATTER = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });
const USD_FORMATTER = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

const toNumber = (value) => {
  const num = typeof value === 'number' ? value : Number(value || 0);
  return Number.isFinite(num) ? num : 0;
};

export const formatBillAmount = (amount, currency, t) => {
  const num = toNumber(amount);
  const cur = String(currency || 'RUB').toUpperCase();
  if (cur === 'USDT') return `${USD_FORMATTER.format(num)} USDT`;
  if (cur === 'USD') return `$${USD_FORMATTER.format(num)}`;
  const suffix = typeof t === 'function' ? t('subRubSign') : 'р';
  return `${RUB_FORMATTER.format(num)} ${suffix}`;
};

export const formatRubAmount = (amount, t) => formatBillAmount(amount, 'RUB', t);
